package api.repository.auth

import api.service.auth.ServiceAuthentication
import dev.gitlive.firebase.auth.FirebaseAuthException
import firebaseAuth
import web.prompts.alert

class ImplRepoAuthentication (val serviceAuthentication: ServiceAuthentication): RepositoryAuthentication{
    override suspend fun login(email: String, password: String): Boolean {
        return try {
        if (serviceAuthentication.login(email, password)){
                val user = firebaseAuth.signInWithEmailAndPassword(email, password).user
            alert("${user?.uid}")
            user != null
        } else {
            false
        }
        } catch (e: FirebaseAuthException){ throw e }
    }

    override suspend fun logout() {
        return serviceAuthentication.logout()
    }

    override suspend fun checkCurrentUser(): Boolean {
        return serviceAuthentication.checkCurrentUser()
    }

}